/* Hallmark · component: auth-verify-email · genre: modern-minimal · theme: project system
 * states: default · hover · focus · active (static screen — no loading/error/success branch)
 * pre-emit critique: P4 H5 E4 S5 R5 V4
 */

/**
 * VerifyEmailPage — pdf-api's own "check your inbox" screen.
 *
 * Wired through `config.auth.components.verifyEmail`. No auth logic at all: the
 * register flow routes here and passes the address through router state.
 *
 * Redesign vs. the kernel default: the kernel centres a 16×16 icon circle above
 * a 3xl centred title. Left-aligned here, same as the other four auth screens,
 * and the icon shrinks to a marker rather than a decoration — the address is
 * what the user came to check.
 */

import { Button } from '@xhubio-saas/core-frontend/ui-components'
import { ArrowLeft, Mail } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { AuthHeading, CONTROL_TRANSITION, FIELD_RING } from './authUi'

export function VerifyEmailPage() {
  const { t } = useTranslation()
  const location = useLocation()
  const email = (location.state as { email?: string } | null)?.email || ''

  return (
    <div className="flex w-full flex-col gap-8">
      <div className="flex flex-col gap-6">
        <div className="flex h-9 w-9 items-center justify-center rounded-md bg-primary/10 text-primary">
          <Mail aria-hidden className="h-5 w-5" />
        </div>
        <AuthHeading
          title={t('auth.verifyEmailTitle')}
          description={t('auth.verifyEmailDescription')}
        />
      </div>

      {/* The address the mail went to — mono, because it is data the user is
          checking character by character against their inbox. */}
      {email && (
        <p className="rounded-md bg-muted px-3 py-2 font-mono text-sm break-all">{email}</p>
      )}

      <div className="flex flex-col gap-2 text-sm text-muted-foreground">
        <p>{t('auth.verifyEmailInstructions')}</p>
        <p>{t('auth.verifyEmailSpam')}</p>
      </div>

      <div className="flex">
        <Button variant="outline" asChild className={CONTROL_TRANSITION}>
          <Link to="/login" className={FIELD_RING}>
            <ArrowLeft aria-hidden className="mr-2 h-4 w-4" />
            {t('auth.backToLogin')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
